import LegalLayout, { LegalH2, LegalP } from "@/components/LegalLayout";
import { openCookieSettings } from "@/lib/consent";

const COOKIES = [
    ["Técnicas y necesarias", "Funcionamiento básico de la web, recordar tu elección de cookies, acceso al panel", "No"],
    ["Analíticas", "Saber cuántas personas visitan la web y qué páginas leen", "Sí"],
    ["Publicitarias (píxel de Meta)", "Medir la eficacia de los anuncios y mostrarte contenidos relevantes en Instagram y Facebook", "Sí"],
    ["YouTube (youtube-nocookie.com)", "Reproducir los vídeos de testimonios; solo al pulsar play en un testimonio", "Sí"],
];

export default function PoliticaCookies() {
    return (
        <LegalLayout eyebrow="Legal" title="Política de Cookies">
            <LegalH2>Qué son</LegalH2>
            <LegalP>
                Las cookies son pequeños archivos que se guardan en tu dispositivo al
                navegar y permiten recordar información sobre tu visita.
            </LegalP>

            <LegalH2>Cookies que usamos</LegalH2>
            <div className="overflow-x-auto mb-6">
                <table className="w-full border-collapse text-sm">
                    <thead>
                        <tr>
                            <th className="text-left py-3 pr-4 border-b border-gold/40 text-gold font-medium">
                                Tipo
                            </th>
                            <th className="text-left py-3 px-4 border-b border-gold/40 text-gold font-medium">
                                Para qué
                            </th>
                            <th className="text-left py-3 pl-4 border-b border-gold/40 text-gold font-medium">
                                ¿Necesita tu consentimiento?
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {COOKIES.map(([t, p, c], i) => (
                            <tr key={i}>
                                <td className="py-3 pr-4 border-b border-white/10 text-zinc-200 font-light align-top">
                                    {t}
                                </td>
                                <td className="py-3 px-4 border-b border-white/10 text-zinc-400 font-light align-top">
                                    {p}
                                </td>
                                <td className="py-3 pl-4 border-b border-white/10 text-zinc-400 font-light align-top">
                                    {c}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <LegalP>
                Las cookies analíticas y publicitarias <strong className="text-zinc-100 font-medium">no se instalan hasta que las aceptas</strong>{" "}
                en el banner. Puedes aceptarlas, rechazarlas o configurarlas, y cambiar tu
                decisión en cualquier momento desde el enlace{" "}
                <button
                    onClick={openCookieSettings}
                    data-testid="cookies-page-configure-link"
                    className="text-gold underline underline-offset-2 hover:text-beam"
                >
                    "Configurar cookies"
                </button>{" "}
                del pie de página.
            </LegalP>

            <LegalH2>Cómo desactivarlas desde tu navegador</LegalH2>
            <LegalP>
                También puedes bloquear o eliminar las cookies desde la configuración de
                Chrome, Safari, Firefox o Edge.
            </LegalP>

            <LegalH2>Contacto</LegalH2>
            <LegalP>
                Para cualquier duda sobre esta política puedes escribir a{" "}
                <a
                    href="mailto:santilorenzo@desactivaelpatron.com"
                    data-testid="cookies-contact-email"
                    className="text-gold underline underline-offset-2 hover:text-beam"
                >
                    santilorenzo@desactivaelpatron.com
                </a>
                .
            </LegalP>

            <LegalH2>Actualizaciones</LegalH2>
            <LegalP>
                Esta política puede actualizarse. Última actualización: 29 de septiembre de
                2026.
            </LegalP>
        </LegalLayout>
    );
}
